import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {ButtonNew} from '@components/common/base/buttons'
import {useByTimeStore} from '@components/statistics/by-time/by-time-store'
import {TwResetBlock} from '@components/statistics/by-time/containers'

export const ResetFiltersBlock = observer(() => {
  const [, store] = useByTimeStore()

  return (
    <TwResetBlock>
      <ButtonNew onClick={store.setDefaultFilterValues}>
        {Lang.msg.none}
      </ButtonNew>
      <div className="min-w-[180px]">{store.filtersSummary}</div>
    </TwResetBlock>
  )
})
